import React from 'react';

import SparePartStockList from 'components/organisms/SparePartStock';

const WorkshopSparePartStockList: React.FunctionComponent = () => {
  return <SparePartStockList />;
};

export default WorkshopSparePartStockList;
